<template>
  <div class="my-like-empty">
    <img src="../../assets/images/mypooq/icon-error-74.png" alt="에러 아이콘">
    <p v-html="text" tabindex="0"></p>
  </div>
</template>

<script>
export default {
  name: 'EmptyList',
  props: {
    text: {
      type: String
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/my.scss"></style>
